
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/snowflake-rbac",
      function () {
        return require("private-next-pages/sources/snowflake-rbac.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/snowflake-rbac"])
      });
    }
  